import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const shutdownAttachmentsKey = (shutdownId) => [
  'shutdownAttachments',
  shutdownId,
];

const shutdownAttachmentsQuery = async ({ queryKey }) => {
  const [_, shutdownId] = queryKey;

  return await request.get(
    `/Alert/attachments/${shutdownId}`,
    {},
    `При загрузке вложений произошла ошибка`
  );
};

const shutdownAttachmentDataQuery = async ({ queryKey }) => {
  const [_, alertId, fileName] = queryKey;

  return await request.get(
    `/Alert/attachment`,
    { alertId, fileName },
    `При загрузке данных вложения произошла ошибка`
  );
};

export const useShutdownAttachments = (shutdownId, options) =>
  useQuery(
    shutdownAttachmentsKey(shutdownId),
    shutdownAttachmentsQuery,
    options
  );

export const fetchAttachmentData = async ({
  queryClient,
  shutdownId,
  fileName,
  options,
}) =>
  await queryClient.fetchQuery(
    ['shutdownAttachmentData', shutdownId, fileName],
    shutdownAttachmentDataQuery,
    options
  );
